<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Details du Professeur" />
            <ProfesseursDetails/>
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ProfesseursDetails from './ProfesseursDetails.vue'


export default {
    name: 'MouvementPage',
    components: {
        NavBar,
        PageTitle,
        ProfesseursDetails,
        FooterComp,
    }
}
</script>